import { Link } from 'react-router-dom'
import Logo from '../../components/brand/Logo.jsx'
import LanguageSwitch from '../../components/ui/LanguageSwitch.jsx'

/*
 * Shared auth scaffold (register / forgot-password) used until those flows are
 * fully re-implemented. Keeps the DESIGN.md §B visual frame so the routes are
 * navigable and on-brand from day one.
 */
export default function SimpleAuthCard({ title, subtitle, children, maxWidth = 430, backLink = true }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      background: 'radial-gradient(1200px 600px at 80% -10%,#efe9fb,#f6f4fb)',
    }}>
      <div style={{ position: 'absolute', top: 22, right: 22 }}><LanguageSwitch /></div>
      <div style={{ width: '100%', maxWidth }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 22 }}>
          <Link to="/"><Logo size={34} /></Link>
        </div>
        <div style={{
          background: '#fff', borderRadius: 'var(--radius-card-lg)', border: '1px solid var(--color-border)',
          boxShadow: 'var(--shadow-card)', padding: '32px 30px', animation: 'vfade .25s ease',
        }}>
          <h1 style={{ fontFamily: 'var(--font-title)', fontSize: 23, fontWeight: 700, color: 'var(--color-ink)', textAlign: 'center', marginBottom: 4 }}>{title}</h1>
          {subtitle && <p style={{ textAlign: 'center', color: 'var(--color-text)', fontSize: 14, marginBottom: 20 }}>{subtitle}</p>}
          {children}
          {backLink && (
            <div style={{ textAlign: 'center', fontSize: 14, color: 'var(--color-text)', marginTop: 20 }}>
              <Link to="/login" style={{ fontWeight: 600, color: 'var(--color-primary)' }}>Retour à la connexion</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
